<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			:defaultOrderByAscending="false"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("E-Mails"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "to",
					name: this.__("Recipient"),
				},
				{
					id: "subject",
					name: this.__("Subject"),
				},
				{
					id: "date",
					name: this.__("Time"),
					timeago: true,
				},
				{
					id: "date_raw",
					name: this.__("Date"),
					render: (f, x) => x.date,
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			return window.baseUrl + "/admin/email_logs/" + row.id.replace("#", "");
		},
	},
};
</script>
